module.exports = __webpack_public_path__ + "static/media/Left fist bottom.02930166.svg";